"use client";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export interface PurchaseOrderDraft {
  number: string;
  file: File | null;
}

export const EMPTY_PURCHASE_ORDER: PurchaseOrderDraft = { number: "", file: null };

const PURCHASE_ORDER_ACCEPT = ".pdf,.jpg,.jpeg,.png,.heic,.heif";

export function isPurchaseOrderDraftReady(draft: PurchaseOrderDraft): boolean {
  return draft.number.trim().length > 0 && draft.file !== null;
}

export function PurchaseOrderFields({
  idPrefix,
  value,
  onChange,
}: {
  idPrefix: string;
  value: PurchaseOrderDraft;
  onChange: (next: PurchaseOrderDraft) => void;
}) {
  const numberId = `${idPrefix}-purchase-order-number`;
  const fileId = `${idPrefix}-purchase-order-file`;
  return (
    <div className="space-y-3">
      <div className="space-y-1.5">
        <Label htmlFor={numberId}>PO number</Label>
        <Input
          id={numberId}
          required
          maxLength={100}
          autoComplete="off"
          value={value.number}
          onChange={(event) => onChange({ ...value, number: event.target.value })}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor={fileId}>PO file</Label>
        <Input
          id={fileId}
          type="file"
          required
          aria-describedby={`${fileId}-hint`}
          accept={PURCHASE_ORDER_ACCEPT}
          onChange={(event) =>
            onChange({ ...value, file: event.target.files?.[0] ?? null })
          }
        />
        <p id={`${fileId}-hint`} className="text-xs text-muted-foreground">
          Upload your purchase order as a PDF or image.
        </p>
      </div>
    </div>
  );
}
